import React from 'react';
import { Trans } from '@lingui/react/macro';
import { ValidatingInput, ValidationSummary } from '@/components/forms/validation';
import Banner from '@/components/Banner';
import { t } from '@lingui/core/macro';
import { TextArea } from '@ygtechnologies/bygr-frontend-component-library';
import { AlertBanner } from '@ygtechnologies/rubus-ui';

export interface LinkToUnitNameProps {
    name: string;
    onNameChange: (name: string) => void;
    onDescriptionChange: (description: string) => void;
    description: string;
}

export const LinkToUnitName: React.FC<LinkToUnitNameProps> = ({ name, onNameChange, description, onDescriptionChange }) => {
    // const ref = useRef<HTMLInputElement>(null);
    // useEffect(() => {
    //     if (ref.current) {
    //         ref.current.focus();
    //     }
    // }, [ref]);

    return (
        <div>
            <AlertBanner type="info">
                <Trans>
                    <strong>Please note</strong> - option title and description will be visible to the buyer.
                </Trans>
            </AlertBanner>

            <div className="form columns-1">
                <label>
                    <Trans>Option title</Trans>
                    <ValidatingInput
                        // ref={ref}
                        fieldName={t`Title`}
                        required
                        className="form-control"
                        value={name}
                        onChange={(e) => onNameChange(e.target.value)}
                    />
                </label>
                <label>
                    <Trans>Description</Trans>
                    <TextArea
                        onChange={(e) => onDescriptionChange(e.target.value)}
                        value={description}
                        minRows={3}
                        autoResize
                        placeholder={t`Description for the option`}
                        className="form-control"
                    />
                </label>
            </div>

            <ValidationSummary />
        </div>
    );
};
